import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { Alert, Button, Table } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as Sites from '../store/Sites';
import * as StudySites from '../store/StudySites';
import * as utility from '../data/Utility';
import * as sortfilter from '../data/SortFilter';


class ManageSitesInternal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
			isShowingFilter: false,
			currentFilters: {},
			currentSortDirection: {},
			currentSortingColumn: '',
            allFetched: false
        }
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
        this.initialize(null);
    }

    componentDidUpdate(prevProps) {
        this.initialize(prevProps);
    }

    handleSiteSelected(id) {
        const history = this.props.history;
        if (history.location.pathname === paths.manageSites) {
            history.push({
                pathname: paths.site,
                state: {
                    create: false,
                    editing: false,
                    siteId: id
                }
            });
        }
    }

    initialize(prevProps) {
        const accountsState = this.props.accountsState;
        const authenticated = Accounts.authenticatedAdministrator(accountsState);
        if (Accounts.authenticatedPrevProps(prevProps, authenticated, accountsState.fetching, !this.state.allFetched)) {
            this.props.sitesDispatch.getAll();
            this.props.studySitesDispatch.getAll();
            this.setState({
                allFetched: true
            });
        }
    }


	toggleFilter() {
		if ( this.state.isShowingFilter ) {
			this.setState({ currentFilters: {} });
		}
		this.setState({ isShowingFilter: ! this.state.isShowingFilter });
	}

	onSortChange = (currentColumn) => {
		let currentSortDirection = this.state.currentSortDirection;
		let nextSort = 'default';

		switch ( currentSortDirection[currentColumn] ) {
			case "down": nextSort = 'default'; break;
			case "up"  : nextSort = 'down'; break;
			default    : nextSort = 'up'; break;
		}

		let newCurrentSortDirection = {};
		newCurrentSortDirection[currentColumn] = nextSort;

		this.setState({
			currentSortDirection: newCurrentSortDirection,
			currentSortingColumn: currentColumn,
		});
	};

	onFilterChange = (e) => {
		this.setState({ currentFilters: {...this.state.currentFilters, [e.target.name]: e.target.value } });
	};

	ColumnHeader = (props) => {
		sortfilter.filterAssociation[props.recordKey] = props.label;
		let val = this.state.currentFilters[props.label];
		if ( val === undefined ) {
			val = '';
		}
		return <sortfilter.ColHeader value={val} onChange={this.onFilterChange.bind(this)} sortDir={this.state.currentSortDirection} onSortChange={this.onSortChange} showFilter={this.state.isShowingFilter} label={props.label} recordKey={props.recordKey} />
	};


    render() {
        if (!Accounts.authenticatedAdministrator(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        var error = false;
        var message = "";
        var siteList = null;

        const sites = this.props.sitesState.all;
        const studySites = this.props.studySitesState.all;
        if (sites != null &&
            sites.map != null &&
            studySites != null &&
            studySites.forEach != null) {
            const editTitle = "Edit";
            var rowNum = 1;
            var studyList = null;

            let sList = [...sites].map(site => {
                studyList = [];
                studySites.forEach(studySite => {
                    if (studySite.site.id === site.id) {
                        studyList.push(studySite.study);
                    }
                });
                const studyNames = utility.getNamesFromArray(studyList);

				return ({ ...site,
						studyNames: studyNames
				});
            });
			sList = sortfilter.filterData( sList, this.state.currentFilters );

            siteList = [...sList].sort( sortfilter.sortingDetails(this.state.currentSortingColumn,this.state.currentSortDirection).fn ).map(site => {
                return (
                    <tr key={site.id} onClick={this.handleSiteSelected.bind(this, site.id)}>
                        <th scope="row">{rowNum++}</th>
                        <td>{site.name}</td>
                        <td>{site.code}</td>
                        <td>{site.studyNames}</td>
                        <td>
                            <Button className="button-inverse" title={editTitle} tag={Link} to={{ pathname: paths.site, state: { create: false, siteId: site.id } }}>{editTitle}</Button>
                        </td>
                    </tr>
                );
            });
        }
        else {
            error = true;
            message = "Error retrieving sites.";
        }

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";

        return (
            <div>
                <h1>Manage Sites</h1>
                <Button className="button filter_button" id="btnFilter" title="Filter" onClick={this.toggleFilter.bind(this)}> Filter </Button>
                <br />
                {displayMessage && <Alert color={alertColor}>{message}</Alert>}
                <Table striped hover>
                    <thead>
                        <tr>
                            <th>#</th>
							<this.ColumnHeader label="Name" recordKey="name" />
							<this.ColumnHeader label="Code" recordKey="code" />
							<this.ColumnHeader label="Studies" recordKey="studyNames" />
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {siteList}
                    </tbody>
                </Table>
            </div>
        );
    }
}

const ManageSitesConnect = withRouter(connect(
    state => ({
        accountsState: state.accounts,
        sitesState: state.sites,
        studySitesState: state.studySites
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        sitesDispatch: bindActionCreators(Sites.actionCreators, dispatch),
        studySitesDispatch: bindActionCreators(StudySites.actionCreators, dispatch)
    })
)(ManageSitesInternal));

export default class ManageSites extends React.Component {
    render() {
        return (
            <ErrorBoundary>
                <ManageSitesConnect />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ManageSites.js